import type { PublicSlotKey } from '@/apilib';
import type { SectionizerPublicApi } from './api';

export const SectionizerApiKey: PublicSlotKey<SectionizerPublicApi> = {
  name: 'SectionizerApi',
  public: true,
};
